// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AppstoreAddOutlinedSvg from "@fishx/icons-svg/es/asn/AppstoreAddOutlined";
import FishxIcon from '../components/FishxIcon';

var AppstoreAddOutlined = function AppstoreAddOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AppstoreAddOutlinedSvg
  }));
};

AppstoreAddOutlined.displayName = 'AppstoreAddOutlined';
export default React.forwardRef(AppstoreAddOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AppstoreAddOutlined.js
// module id = 2008
// module chunks = 0